// Shared between FloatingBatchActionBar's stickyTopActionRoot height and
// GridHeader's sticky thead top offset, so the thead stacks directly below
// the sticky action bar instead of both competing for top: 0.
export const ACTION_BAR_HEIGHT = 56
